<app-heyjom-navbar></app-heyjom-navbar>
<div class="main-container">
    <router-outlet></router-outlet>
</div>
